/**
 * 判断变量是否已定义
 * @param {object} v
 * @returns {boolean}
 */
export const isDef = <T>(v: T | undefined | null): v is T => v !== undefined && v !== null

/**
 * 判断变量是否未定义
 * 增加了 type guards: https://www.typescriptlang.org/docs/handbook/advanced-types.html#typeof-type-guards
 * @param {object} v
 * @returns {boolean}
 */
export const isUndef = (v: unknown): v is undefined | null => v === undefined || v === null

/**
 * 获取cgi环境
 * @param sandbox
 * @returns {string}
 */
export function getCgiEnv(sandbox: string): string {
  if (sandbox === "1") {
    return "sandbox."
  } else if (sandbox === "2") {
    return "dev."
  }
  return ""
}

/**
 * 获得当前的时间
 * @returns {number}
 */
export function getNowTimeStamp(): number {
  let nowDate = (window as any)._serverTime ? new Date((window as any)._serverTime) : new Date()

  if (!isValidDate(nowDate)) {
    nowDate = new Date()
  }

  return nowDate.getTime()
}
/**
 * 判断时间是否有效
 * @param {} date
 * @returns {boolean}
 */
export function isValidDate(date: Date): boolean {
  return date instanceof Date && !isNaN(date.getTime())
}

/**
 *判断时间是否在有效期内
 */
export function checkTimeValid(begin?: string | number | Date, end?: string | number | Date): boolean {
  if (isUndef(begin) || isUndef(end)) return false
  const now = getNowTimeStamp()

  const beginTime = UTC8TimeToTimeStamp(begin)
  const endTime = UTC8TimeToTimeStamp(end)

  return beginTime <= now && now <= endTime
}

export function extend(obj: Record<string, unknown>, ...args: any[]): any {
  for (const newObj of args) {
    Object.keys(newObj).forEach(key => {
      if (isUndef(obj[key])) {
        obj[key] = newObj[key]
      }
    })
  }
  return obj
}

export function safeStringify(obj: Record<string, unknown> | unknown | string): string {
  if (typeof obj === "string") return obj
  // 声明cache变量，便于匹配是否有循环引用的情况
  const cache: any[] = []
  const str = JSON.stringify(obj, (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (cache.indexOf(value) !== -1) {
        // 移除
        return
      }
      // 收集所有的值
      cache.push(value)
    }
    return value
  })
  return str
}

/**
 * 解决国外用户时间判断问题
 * @param {} bjTime 北京时间，格式为2022-02-04 00:00:00 或 2022/02/04 00:00:00
 * return 转换为格林威治标准时间时间戳
 */
export function UTC8TimeToTimeStamp(bjTime) {
  return new Date(`${bjTime.replace(/-/g, "/")} GMT+08:00`).getTime()
}
